import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ForestIcon from '@mui/icons-material/Forest';
import { Link } from 'react-router-dom';

export default function PageHero({ title, subtitle, breadcrumbs = [] }) {
  return (
    <Box
      sx={{
        pt: { xs: 14, md: 18 },
        pb: { xs: 8, md: 12 },
        background: 'linear-gradient(160deg, #e8f5e9 0%, #f1f8e9 40%, #c8e6c9 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Organic shape decorations */}
      <Box sx={{
        position: 'absolute', top: -80, right: -60,
        width: 380, height: 380,
        borderRadius: '60% 40% 70% 30% / 40% 60% 30% 70%',
        background: 'rgba(46,125,50,0.07)',
        pointerEvents: 'none',
      }} />
      <Box sx={{
        position: 'absolute', bottom: -50, left: '15%',
        width: 220, height: 220,
        borderRadius: '40% 60% 30% 70% / 60% 40% 70% 30%',
        background: 'rgba(85,139,47,0.06)',
        pointerEvents: 'none',
      }} />
      {/* Subtle dot pattern */}
      <Box sx={{
        position: 'absolute', inset: 0,
        backgroundImage: 'radial-gradient(rgba(46,125,50,0.08) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
        pointerEvents: 'none',
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {breadcrumbs.length > 0 && (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" sx={{ color: 'rgba(46,125,50,0.4)' }} />}
            sx={{ mb: 3 }}
          >
            <MuiLink
              component={Link}
              to="/"
              underline="none"
              sx={{ fontSize: '0.78rem', color: '#558b2f', letterSpacing: '0.06em', '&:hover': { color: '#2e7d32' } }}
            >
              Inicio
            </MuiLink>
            {breadcrumbs.map((crumb, i) => (
              i === breadcrumbs.length - 1 ? (
                <Typography key={i} sx={{ fontSize: '0.78rem', color: '#2e7d32', letterSpacing: '0.06em', fontWeight: 600 }}>
                  {crumb.label}
                </Typography>
              ) : (
                <MuiLink
                  key={i}
                  component={Link}
                  to={crumb.path}
                  underline="none"
                  sx={{ fontSize: '0.78rem', color: '#558b2f', '&:hover': { color: '#2e7d32' } }}
                >
                  {crumb.label}
                </MuiLink>
              )
            ))}
          </Breadcrumbs>
        )}

        <Box sx={{
          display: 'inline-flex', alignItems: 'center', gap: 0.8,
          px: 2, py: 0.6, mb: 2.5,
          background: 'rgba(46,125,50,0.10)',
          border: '1px solid rgba(46,125,50,0.25)',
          borderRadius: 20,
        }}>
          <ForestIcon sx={{ color: '#2e7d32', fontSize: 14 }} />
          <Typography variant="overline" sx={{ color: '#2e7d32', fontSize: '0.66rem' }}>
            FENAGRO APL
          </Typography>
        </Box>

        <Typography
          variant="h1"
          sx={{
            color: '#1a3a1e',
            fontSize: { xs: '2.2rem', md: '3.2rem', lg: '4rem' },
            maxWidth: 700,
          }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography
            variant="body1"
            sx={{ color: '#4a6741', mt: 2, maxWidth: 560, fontSize: '1.05rem' }}
          >
            {subtitle}
          </Typography>
        )}
      </Container>
    </Box>
  );
}
